import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, url }) => {
  const siteName = "QryptShield | Post-Quantum VPN";
  
  return (
    <Helmet>
      <title>{title ? `${title} | ${siteName}` : siteName}</title>
      <meta name="description" content={description || "Military-grade post-quantum VPN for enterprises and remote teams."} />
      <meta name="keywords" content={keywords || "post-quantum VPN, enterprise VPN, wireguard, secure tunnel, qryptshield"} />
      
      {/* Open Graph / Social Media */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url || "https://qryptshield.com"} />
      
      {/* Canonical Link for Google */}
      <link rel="canonical" href={url || "https://qryptshield.com"} />
    </Helmet>
  );
};

export default SEO;